import { render } from "./index.vue?vue&type=template&id=c4234446&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=c4234446&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c4234446"

export default script